import { render } from "./PeoplePage.vue?vue&type=template&id=698b1284&ts=true"
import script from "./PeoplePage.vue?vue&type=script&lang=ts"
export * from "./PeoplePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__